module.exports = __webpack_public_path__ + "static/esailingTV-c6cdda18a6c9c3a2ababb06886be46e0.webp";